{
    "barometern": {
        "celebrate": {
            "title": "Fira",
            "text": "Uppvakta någon på födelsedagen, berätta att ni gift er, tacka för uppvaktning eller meddela nytillskottet i familjen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/",
            "linkText": "Se firaannonser",
            "link": "https://familj.barometern.se/fira"
        },
        "market": {
            "title": "Köp och sälj",
            "text": "Sälj din gamla bil, sök en ny bostad eller efterlys ett bortsprunget husdjur. Du hittar köp- och säljannonserna i den tryckta tidningen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/"
        },
        "memorial": {
            "title": "Döds- och minnesannonser",
            "text": "För att sätta in en dödsannons, minnesannons eller ett sorgetack, kontakta säljsupport.",
            "buttonPhoneText": "0480-591 40",
            "buttonPhoneLink": "tel:048059140",
            "buttonMailText": "Maila bokning",
            "buttonMailLink": "mailto:bokning@barometern.se",
            "linkText": "Se döds- och minnesannonser",
            "link": "https://familj.barometern.se/minnas"
        }
    },
    "blt": {
        "celebrate": {
            "title": "Fira",
            "text": "Uppvakta någon på födelsedagen, berätta att ni gift er, tacka för uppvaktning eller meddela nytillskottet i familjen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/",
            "linkText": "Se firaannonser",
            "link": "https://familj.blt.se/fira"
        },
        "market": {
            "title": "Köp och sälj",
            "text": "Sälj din gamla bil, sök en ny bostad eller efterlys ett bortsprunget husdjur. Du hittar köp- och säljannonserna i den tryckta tidningen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/"
        },
        "memorial": {
            "title": "Döds- och minnesannonser",
            "text": "För att sätta in en minnesannons kontakta säljsupport. För bokning av dödsannons och sorgetack, kontakta begravningsbyrå.",
            "buttonPhoneText": "0455-77137",
            "buttonPhoneLink": "tel:045577000",
            "buttonMailText": "Maila bokning",
            "buttonMailLink": "mailto:bokning@bltsydostran.se",
            "linkText": "Se döds- och minnesannonser",
            "link": "https://familj.blt.se/minnas"
        }
    },
    "bt": {
        "celebrate": {
            "title": "Fira",
            "text": "Uppvakta någon på födelsedagen, berätta att ni gift er, tacka för uppvaktning eller meddela nytillskottet i familjen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/",
            "linkText": "Se firaannonser",
            "link": "https://familj.bt.se/fira"
        },
        "market": {
            "title": "Köp och sälj",
            "text": "Sälj din gamla bil, sök en ny bostad eller efterlys ett bortsprunget husdjur. Du hittar köp- och säljannonserna i den tryckta tidningen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/"
        },
        "memorial": {
            "title": "Döds- och minnesannonser",
            "text": "För att sätta in en dödsannons, minnesannons eller ett sorgetack, kontakta säljsupport.",
            "buttonPhoneText": "033-7000 700",
            "buttonPhoneLink": "tel:0337000700",
            "buttonMailText": "Maila bokning",
            "buttonMailLink": "mailto:annonssupport@bt.se",
            "linkText": "Se döds- och minnesannonser",
            "link": "https://familj.bt.se/minnas"
        }
    },
    "kristianstadsbladet": {
        "celebrate": {
            "title": "Fira",
            "text": "Uppvakta någon på födelsedagen, berätta att ni gift er, tacka för uppvaktning eller meddela nytillskottet i familjen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/",
            "linkText": "Se firaannonser",
            "link": "https://familj.kristianstadsbladet.se/fira"
        },
        "market": {
            "title": "Köp och sälj",
            "text": "Sälj din gamla bil, sök en ny bostad eller efterlys ett bortsprunget husdjur. Du hittar köp- och säljannonserna i den tryckta tidningen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/"
        },
        "memorial": {
            "title": "Döds- och minnesannonser",
            "text": "För att sätta in en minnesannons kontakta säljsupport. För bokning av dödsannons och sorgetack, kontakta begravningsbyrå.",
            "buttonPhoneText": "044-18 55 32",
            "buttonPhoneLink": "tel:044185532",
            "linkText": "Se döds- och minnesannonser",
            "link": "https://familj.kristianstadsbladet.se/minnas"
        }
    },
    "nsk": {
        "celebrate": {
            "title": "Fira",
            "text": "Uppvakta någon på födelsedagen, berätta att ni gift er, tacka för uppvaktning eller meddela nytillskottet i familjen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/",
            "linkText": "Se firaannonser",
            "link": "https://familj.nsk.se/fira"
        },
        "market": {
            "title": "Köp och sälj",
            "text": "Sälj din gamla bil, sök en ny bostad eller efterlys ett bortsprunget husdjur. Du hittar köp- och säljannonserna i den tryckta tidningen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/"
        },
        "memorial": {
            "title": "Döds- och minnesannonser",
            "text": "För att sätta in en minnesannons kontakta säljsupport. För bokning av dödsannons och sorgetack, kontakta begravningsbyrå.",
            "buttonPhoneText": "044-18 55 32",
            "buttonPhoneLink": "tel:044185532",
            "linkText": "Se döds- och minnesannonser",
            "link": "https://familj.nsk.se/minnas"
        }
    },
    "smp": {
        "celebrate": {
            "title": "Fira",
            "text": "Uppvakta någon på födelsedagen, berätta att ni gift er, tacka för uppvaktning eller meddela nytillskottet i familjen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/",
            "linkText": "Se firaannonser",
            "link": "https://familj.smp.se/fira"
        },
        "market": {
            "title": "Köp och sälj",
            "text": "Sälj din gamla bil, sök en ny bostad eller efterlys ett bortsprunget husdjur. Du hittar köp- och säljannonserna i den tryckta tidningen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/"
        },
        "memorial": {
            "title": "Döds- och minnesannonser",
            "text": "För att sätta in en dödsannons, minnesannons eller ett sorgetack, kontakta säljsupport.",
            "buttonPhoneText": "0470-77 05 36",
            "buttonPhoneLink": "tel:0470770536",
            "buttonMailText": "Maila bokning",
            "buttonMailLink": "mailto:bokning@smp.se",
            "linkText": "Se döds- och minnesannonser",
            "link": "https://familj.smp.se/minnas"
        }
    },
    "sydostran": {
        "celebrate": {
            "title": "Fira",
            "text": "Uppvakta någon på födelsedagen, berätta att ni gift er, tacka för uppvaktning eller meddela nytillskottet i familjen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/",
            "linkText": "Se firaannonser",
            "link": "https://familj.sydostran.se/fira"
        },
        "market": {
            "title": "Köp och sälj",
            "text": "Sälj din gamla bil, sök en ny bostad eller efterlys ett bortsprunget husdjur. Du hittar köp- och säljannonserna i den tryckta tidningen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/"
        },
        "memorial": {
            "title": "Döds- och minnesannonser",
            "text": "För att sätta in en minnesannons kontakta säljsupport. För bokning av dödsannons och sorgetack, kontakta begravningsbyrå.",
            "buttonPhoneText": "0455-77137",
            "buttonPhoneLink": "tel:045577137",
            "buttonMailText": "Maila bokning",
            "buttonMailLink": "mailto:bokning@bltsydostran.se",
            "linkText": "Se döds- och minnesannonser",
            "link": "https://familj.sydostran.se/minnas"
        }
    },
    "trelleborgsallehanda": {
        "celebrate": {
            "title": "Fira",
            "text": "Uppvakta någon på födelsedagen, berätta att ni gift er, tacka för uppvaktning eller meddela nytillskottet i familjen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/",
            "linkText": "Se firaannonser",
            "link": "https://familj.trelleborgsallehanda.se/fira"
        },
        "market": {
            "title": "Köp och sälj",
            "text": "Sälj din gamla bil, sök en ny bostad eller efterlys ett bortsprunget husdjur. Du hittar köp- och säljannonserna i den tryckta tidningen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/"
        },
        "memorial": {
            "title": "Döds- och minnesannonser",
            "text": "För att sätta in en dödsannons, minnesannons eller ett sorgetack, kontakta säljsupport.",
            "buttonPhoneText": "0410-545 70",
            "buttonPhoneLink": "tel:0410-545 70",
            "linkText": "Se döds- och minnesannonser",
            "link": "https://familj.trelleborgsallehanda.se/minnas"
        }
    },
    "ut": {
        "celebrate": {
            "title": "Fira",
            "text": "Uppvakta någon på födelsedagen, berätta att ni gift er, tacka för uppvaktning eller meddela nytillskottet i familjen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/",
            "linkText": "Se firaannonser",
            "link": "https://familj.ut.se/fira"
        },
        "market": {
            "title": "Köp och sälj",
            "text": "Sälj din gamla bil, sök en ny bostad eller efterlys ett bortsprunget husdjur. Du hittar köp- och säljannonserna i den tryckta tidningen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/"
        },
        "memorial": {
            "title": "Döds- och minnesannonser",
            "text": "För att sätta in en dödsannons, minnesannons eller ett sorgetack, kontakta säljsupport.",
            "buttonPhoneText": "0321-262 00",
            "buttonPhoneLink": "tel:032126200",
            "buttonMailText": "Maila bokning",
            "buttonMailLink": "mailto:annons@ut.se",
            "linkText": "Se döds- och minnesannonser",
            "link": "https://familj.ut.se/minnas"
        }
    },
    "ystadsallehanda": {
        "celebrate": {
            "title": "Fira",
            "text": "Uppvakta någon på födelsedagen, berätta att ni gift er, tacka för uppvaktning eller meddela nytillskottet i familjen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/",
            "linkText": "Se firaannonser",
            "link": "https://familj.ystadsallehanda.se/fira"
        },
        "market": {
            "title": "Köp och sälj",
            "text": "Sälj din gamla bil, sök en ny bostad eller efterlys ett bortsprunget husdjur. Du hittar köp- och säljannonserna i den tryckta tidningen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/"
        },
        "memorial": {
            "title": "Döds- och minnesannonser",
            "text": "För att sätta in en dödsannons, minnesannons eller ett sorgetack, kontakta säljsupport.",
            "buttonPhoneText": "0411-55 79 15",
            "buttonPhoneLink": "tel:0411557915",
            "linkText": "Se döds- och minnesannonser",
            "link": "https://familj.ystadsallehanda.se/minnas"
        }
    },
    "olandsbladet": {
        "celebrate": {
            "title": "Fira",
            "text": "Uppvakta någon på födelsedagen, berätta att ni gift er, tacka för uppvaktning eller meddela nytillskottet i familjen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/",
            "linkText": "Se firaannonser",
            "link": "https://familj.olandsbladet.se/fira"
        },
        "market": {
            "title": "Köp och sälj",
            "text": "Sälj din gamla bil, sök en ny bostad eller efterlys ett bortsprunget husdjur. Du hittar köp- och säljannonserna i den tryckta tidningen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/"
        },
        "memorial": {
            "title": "Döds- och minnesannonser",
            "text": "För att sätta in en dödsannons, minnesannons eller ett sorgetack, kontakta säljsupport.",
            "buttonPhoneText": "0485-417 00",
            "buttonPhoneLink": "tel:048541700",
            "linkText": "Se döds- och minnesannonser",
            "link": "https://familj.olandsbladet.se/minnas"
        }
    },
    "meraosterlen": {
        "celebrate": {
            "title": "Fira",
            "text": "Uppvakta någon på födelsedagen, berätta att ni gift er, tacka för uppvaktning eller meddela nytillskottet i familjen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/",
            "linkText": "Se firaannonser",
            "link": "https://familj.ystadsallehanda.se/fira"
        },
        "market": {
            "title": "Köp och sälj",
            "text": "Sälj din gamla bil, sök en ny bostad eller efterlys ett bortsprunget husdjur. Du hittar köp- och säljannonserna i den tryckta tidningen.",
            "buttonText": "Boka annons från 49 kr",
            "buttonLink": "https://privat-gota.cargoselfservice.com/login/"
        },
        "memorial": {
            "title": "Döds- och minnesannonser",
            "text": "För att sätta in en dödsannons, minnesannons eller ett sorgetack, kontakta säljsupport.",
            "buttonPhoneText": "0411-55 79 15",
            "buttonPhoneLink": "tel:0411557915",
            "buttonMailText": "Maila bokning",
            "buttonMailLink": "mailto:annons@osterlenmagasinet.se",
            "linkText": "Se döds- och minnesannonser",
            "link": "https://familj.ystadsallehanda.se/minnas"
        }
    }
}